import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import {
  SettingOutline,
  HomeOutline,
  ProjectOutline,
  CommentOutline,
  DollarOutline,
  CopyrightOutline,
  BuildOutline,
  UserOutline,
  PictureOutline,
  FilterOutline,
  ArrowLeftOutline,
  SaveOutline,
  PlusOutline,
  EditOutline,
  FileTwoTone,
  ArrowDownOutline,
  BorderOutline,
  FileExcelOutline,
  LinkOutline,
  DeleteColumnOutline,
  CheckSquareOutline,
  StepForwardOutline,
  StepBackwardOutline,
  ReloadOutline,
  PlusCircleOutline,
  DeleteOutline,
  AppstoreAddOutline,
  MessageOutline,
  FilePdfOutline,
  LoginOutline,
  LoadingOutline,
  CloseCircleOutline,
  CloseCircleFill,
  CloseSquareFill,
  FilePdfFill,
  LogoutOutline,
  CheckSquareFill,
  MenuFoldOutline,
  MenuUnfoldOutline,
  GlobalOutline,
  EnvironmentOutline,
  CopyOutline,
  CopyTwoTone,
  WifiOutline,
  HistoryOutline,
  FormOutline,
  DisconnectOutline,
  CloseOutline,
  NodeExpandOutline,
  NodeCollapseOutline,
  CheckOutline,
  FileAddOutline,
  MailOutline,
  SendOutline,
  RedoOutline,
  ExportOutline,
  DownloadOutline,
  LockFill,
  SmileOutline,
  PictureTwoTone,
  SortAscendingOutline,
  SortDescendingOutline,
  ArrowRightOutline,
  SyncOutline,
  MinusSquareOutline,
  FileGifOutline,
  FilePptOutline,
  FileImageOutline,
  FileJpgOutline,
  FileOutline,
  FileTextOutline,
  FileUnknownOutline,
  FileWordOutline,
  FileZipOutline,
  CloudSyncOutline,
  UnorderedListOutline,
  InfoOutline,
  SubnodeOutline,
  BranchesOutline,
  BellOutline,
} from '@ant-design/icons-angular/icons';

const icons: IconDefinition[] = [
  SettingOutline,
  HomeOutline,
  ProjectOutline,
  CommentOutline,
  DollarOutline,
  CopyrightOutline,
  BuildOutline,
  UserOutline,
  PictureOutline,
  FilterOutline,
  ArrowLeftOutline,
  SaveOutline,
  PlusOutline,
  EditOutline,
  FileTwoTone,
  ArrowDownOutline,
  BorderOutline,
  FileExcelOutline,
  LinkOutline,
  DeleteColumnOutline,
  CheckSquareOutline,
  StepForwardOutline,
  StepBackwardOutline,
  ReloadOutline,
  PlusCircleOutline,
  DeleteOutline,
  AppstoreAddOutline,
  MessageOutline,
  FilePdfOutline,
  LoginOutline,
  LoadingOutline,
  CloseCircleOutline,
  CloseCircleFill,
  CloseSquareFill,
  FilePdfFill,
  LogoutOutline,
  CheckSquareFill,
  MenuFoldOutline,
  MenuUnfoldOutline,
  GlobalOutline,
  EnvironmentOutline,
  CopyOutline,
  CopyTwoTone,
  WifiOutline,
  HistoryOutline,
  FormOutline,
  DisconnectOutline,
  CloseOutline,
  NodeExpandOutline,
  NodeCollapseOutline,
  CheckOutline,
  FileAddOutline,
  MailOutline,
  SendOutline,
  RedoOutline,
  ExportOutline,
  DownloadOutline,
  LockFill,
  SmileOutline,
  PictureTwoTone,
  SortAscendingOutline,
  SortDescendingOutline,
  ArrowRightOutline,
  SyncOutline,
  MinusSquareOutline,
  FileGifOutline,
  FilePptOutline,
  FileImageOutline,
  FileJpgOutline,
  FileOutline,
  FileTextOutline,
  FileUnknownOutline,
  FileWordOutline,
  FileZipOutline,
  CloudSyncOutline,
  UnorderedListOutline,
  InfoOutline,
  SubnodeOutline,
  BranchesOutline,
  BellOutline,
];

@NgModule({
  imports: [NzIconModule.forRoot(icons)],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule {}
